import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

function AuthSuccess() {
  const [status, setStatus] = useState('processing');
  const navigate = useNavigate();

  useEffect(() => {
    const handleOAuthReturn = async () => {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');
        const code = urlParams.get('code');
        const state = urlParams.get('state');
        
        if (token) {
          // Salvar token no localStorage
          localStorage.setItem('sitri_token', token);
          
          // Verificar se há pedido anônimo para vincular
          try {
            const { obterPedidoAnonimo, limparPedidoAnonimo } = await import('../services/pedidoAnonimo');
            const { vincularPedidoAnonimo } = await import('../services/api');
            const pedidoAnonimo = obterPedidoAnonimo();
            
            if (pedidoAnonimo && pedidoAnonimo.comandaId) {
              await vincularPedidoAnonimo(token, {
                comandaId: pedidoAnonimo.comandaId,
                brand: pedidoAnonimo.brand
              });
              
              // Disparar evento customizado para mostrar toast
              window.dispatchEvent(new CustomEvent('pedidoVinculado', {
                detail: pedidoAnonimo
              }));
              
              limparPedidoAnonimo();
            }
          } catch (error) {
            // Erro silencioso na vinculação
          }
          
          setStatus('success');
          
          // Limpar URL
          window.history.replaceState({}, '', window.location.pathname);
          
          // Aguardar um pouco antes de redirecionar
          setTimeout(() => {
            navigate('/');
          }, 1500);
        } else if (code && state) {
          // Processar callback OAuth
          try {
            const { processOAuthCallback } = await import('../services/api');
            const result = await processOAuthCallback(code, state);
            
            if (result.success) {
              localStorage.setItem('sitri_token', result.token);
              setStatus('success');
              
              // Limpar URL
              window.history.replaceState({}, '', window.location.pathname);
              
              setTimeout(() => {
                navigate('/');
              }, 1500);
            } else {
              setStatus('error');
            }
          } catch (error) {
            console.error('Erro ao processar callback OAuth:', error);
            setStatus('error');
          }
        } else {
          setStatus('error');
        }
      } catch (error) {
        console.error('Erro ao processar OAuth:', error);
        setStatus('error');
      }
    };

    handleOAuthReturn();
  }, [navigate]);

  return (
    <div className="container-fluid vh-100 d-flex align-items-center justify-content-center">
      <div className="text-center">
        <div className="mb-4">
          <img 
            src="https://grubicons.s3.us-east-1.amazonaws.com/logo-grub.png" 
            alt="Logo GRUB" 
            style={{ width: '80px', height: '80px', borderRadius: '50%' }}
          />
        </div>
        
        {status === 'processing' && (
          <>
            <div className="spinner-border text-primary mb-3" role="status">
              <span className="visually-hidden">Carregando...</span>
            </div>
            <h5>Processando login...</h5>
            <p className="text-muted">Aguarde enquanto finalizamos seu acesso</p>
          </>
        )}
        
        {status === 'success' && (
          <>
            <div className="text-success mb-3">
              <i className="bi bi-check-circle" style={{ fontSize: '3rem' }}></i>
            </div>
            <h5 className="text-success">Login realizado com sucesso!</h5>
            <p className="text-muted">Redirecionando...</p>
          </>
        )}
        
        {status === 'error' && (
          <>
            <div className="text-danger mb-3">
              <i className="bi bi-x-circle" style={{ fontSize: '3rem' }}></i>
            </div>
            <h5 className="text-danger">Erro no login</h5>
            <p className="text-muted">Tente novamente</p>
            <button 
              className="btn btn-primary"
              onClick={() => navigate('/')}
            >
              Voltar ao início
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default AuthSuccess;